import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=32b2ed4f&scoped=true&"
import script from "./newsletter.vue?vue&type=script&lang=js&"
export * from "./newsletter.vue?vue&type=script&lang=js&"
import style0 from "./newsletter.vue?vue&type=style&index=0&id=32b2ed4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2ed4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('32b2ed4f', component.options)
    } else {
      api.reload('32b2ed4f', component.options)
    }
    module.hot.accept("./newsletter.vue?vue&type=template&id=32b2ed4f&scoped=true&", function () {
      api.rerender('32b2ed4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/newsletter.vue"
export default component.exports